
import { ArtStates } from "../types/art-status";
import { SelectedFilters } from "../pages/design-detail/comps/filterOptionsDropdown";

type DashboardState = {
  pageIndex: number;
  searchText: string;
  artStatusFilter: ArtStates;
  products?: SelectedFilters | null;
};

export function markDashboardExitToDetails(state: DashboardState) {
  sessionStorage.setItem("isGoBack", "true");
  localStorage.setItem("lastDashboardPage", String(state.pageIndex));
  localStorage.setItem("lastDashboardSearch", state.searchText ?? "");
  localStorage.setItem("lastDashboardFilter", state.artStatusFilter);
  localStorage.setItem("lastDashboardFilterState", JSON.stringify(state.products ?? null));
}

export function clearDashboardState() {
  localStorage.removeItem("lastDashboardPage");
  localStorage.removeItem("lastDashboardSearch");
  localStorage.removeItem("lastDashboardFilter");
  localStorage.removeItem("lastDashboardFilterState");
  sessionStorage.removeItem("isGoBack");
}

export function shouldRestoreDashboardState(): boolean {
  return sessionStorage.getItem("isGoBack") === "true";
}

export function getPersistedFilterData(): SelectedFilters | null {
  const savedFilter = localStorage.getItem("lastDashboardFilterState");
  if (savedFilter) {
    try {
      const parsedFilter = JSON.parse(savedFilter);

      if (
        parsedFilter &&
        typeof parsedFilter === 'object' &&
        Array.isArray(parsedFilter.e) &&
        Array.isArray(parsedFilter.l) &&
        Array.isArray(parsedFilter.u)
      ) {
        return parsedFilter as SelectedFilters;
      }
    } catch (e) {
      console.error("Error parsing lastDashboardFilterState:", e);
    }
  }

  return {
    e: [],
    l: [],
    u: []
  };
}
